import { getResolution } from './dataFeed'
import api from '../../../../api'
import { getSocket } from '../../../../store/redusers/sockets/actions'

const channelToSubscription = new Map()
let assetSoId
let socket
const getRiskData = () => JSON.parse(localStorage.getItem('trading-risk-data'))
const getPricer = () => JSON.parse(localStorage.getItem('trading-pricer'))
export const getHistoryPromise = async (pair, from, to, resolution, asset) => {
	let symbol = encodeURIComponent(pair)
	let riskData = getRiskData()
	let pricer = getPricer()
	// eslint-disable-next-line max-len
	const url = `/history?symbol=${symbol}&resolution=${resolution}&from=${from + '&to=' + to}&userId=${riskData.user}&riskName=${riskData['spread_' + asset.assetType]}&assetType=${asset.assetType}&brandName=${riskData.brand}&delay=0`
	return (await api.chart.getChart(pricer.link
		+ ':' + pricer.tradingViewPort
		+ url))
}

const initUpdateBars = () => {
	if(!socket) return
	socket.on('update', (data) => {
		let asset = data[assetSoId]
		if (!asset) return
		let riskData = getRiskData()
		let tradeTime = asset.utc
		let quoteAssetClass = asset['assetClass']
		let assetClassRiskName = riskData['spread_' + quoteAssetClass]
		let fallback = false
		if (asset[quoteAssetClass] === undefined ||
			asset[quoteAssetClass][assetClassRiskName] === undefined) {
			fallback = true
		}
		let tradePrice = parseFloat(fallback ?
			asset.bidRate :
			asset[quoteAssetClass][assetClassRiskName].bidRate)
		const subscriptionItem = channelToSubscription.get(assetSoId)
		if (subscriptionItem === undefined) {
			return
		}
		const lastDailyBar = subscriptionItem.lastDailyBar;
		const nextDailyBarTime = getNextDailyBarTime(lastDailyBar.time)
		let bar
		if (tradeTime * 1000 >= nextDailyBarTime) {
			bar = {
				close: tradePrice,
				high: tradePrice,
				low: tradePrice,
				open: tradePrice,
				time: nextDailyBarTime
			}
		} else {
			bar = {
				...lastDailyBar,
				close: tradePrice,
				high: Math.max(lastDailyBar.high, tradePrice),
				low: Math.min(lastDailyBar.low, tradePrice)
			}
		}
		subscriptionItem.lastDailyBar = bar;
		subscriptionItem.handlers.forEach(handler => handler.callback(bar));
	})
}

function getNextDailyBarTime(barTime) {
	return barTime + (+getResolution() * 60000)
}

export function subscribeOnStream(
	symbolInfo,
	resolution,
	onRealtimeCallback,
	subscriberUID,
	onResetCacheNeededCallback,
	lastDailyBar,
	asset) {
	assetSoId = asset.assetSoId
	const channelString = asset.assetSoId
	const handler = {
		callback: onRealtimeCallback,
		id: subscriberUID
	}
	let subscriptionItem = channelToSubscription.get(channelString)
	if (subscriptionItem) {
		subscriptionItem.handlers.push(handler)
		return
	}
	subscriptionItem = {
		handlers: [handler],
		lastDailyBar,
		resolution,
		subscriberUID
	}
	channelToSubscription.set(channelString, subscriptionItem)
	// eslint-disable-next-line
	// console.log('[subscribeBars]: Subscribe to streaming. Channel:', channelString)
	socket = getSocket()
	initUpdateBars()
}
export function unsubscribeFromStream(subscriberUID) {
	let channelString
	for (channelString of channelToSubscription.keys()) {
		const subscriptionItem = channelToSubscription.get(channelString)
		const handlerIndex = subscriptionItem.handlers
			.findIndex(handler => handler.id === subscriberUID)
		if (handlerIndex !== -1) {
			subscriptionItem.handlers.splice(handlerIndex, 1)
			if (subscriptionItem.handlers.length === 0) {
				// unsubscribe from the channel, if it was the last handler
				// eslint-disable-next-line
				// console.log('[unsubscribeBars]: Unsubscribe from streaming. Channel:', channelString)
				channelToSubscription.delete(channelString)
				break
			}
		}
	}
}
